import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const OtherProjectDetailWrapper = styled.div`
  width: 100%;
  @media (${mediaQuery.tablet}) {
    padding: 0 24px;
  }
  ${media.xs`
    padding: 0 16px;
  `}
`;

export const OtherProjectDetailContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  .show-more-button {
    margin-top: 0;
    margin-bottom: 24px;
    ::before {
      display: none;
    }
  }
  ${media.xs`
    padding: 0 16px;
  `}
`;

export const OtherProjectDetailContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const ProjectAttribute = styled.div`
  width: 50%;
  margin-bottom: 24px;
  font-size: 14px;
  ${media.xs`
    width: 100%;
  `};
`;

export const ProjectAttributeTitle = styled.p`
  margin: 0 0 4px;
  color: #697684;
  font-weight: 300;
  line-height: 1.43;
  letter-spacing: normal;
`;

export const ProjectAttributeData = styled.p`
  margin: 0;
  color: #333f48;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: normal;
`;

export const Divider = styled.hr`
  clear: both;
  width: 100%;
  margin: 0 0 32px;
  height: 1px;
  background-color: #d2d6da;
  border: none;
  ${media.xs`
    width: auto;
    margin: 0 16px 24px;
  `}
`;
